function cart_custom_shipping_bar(b){

  jQuery("#progress_bar").val(b.original_total_price);
  
var cartPrice = b.original_total_price;
var shippingPrice =  jQuery("#progress_txt").data("amount");
var totalPrice = cartPrice - shippingPrice;

// Format the total price using the specified code
var formattedPrice = (totalPrice / 100).toFixed(2);

// Remove the "-" from the formatted price
formattedPrice = formattedPrice.replace(/-/g, '');

  if(b.item_count > 0){
    jQuery("#progress_txt").removeClass("hide");
  }else{
    jQuery("#progress_txt").addClass("hide");
  }
  if(b.original_total_price >= shippingPrice){
    jQuery(".hide_shipbar").removeClass("hide");
    jQuery(".hide_shipbar").addClass("active");
    jQuery("#progress_txt .bartext").addClass("hide");
    jQuery("#progress_txt .bartext strong").text("$"+formattedPrice);
    
  }else{
    jQuery(".hide_shipbar").removeClass("active");
    jQuery(".hide_shipbar").addClass("hide");
    jQuery("#progress_txt .bartext").removeClass("hide");
     jQuery("#progress_txt .bartext strong").text("$"+formattedPrice);
  }
}

// $(document).ready(function(){
//   $('.moreless-button_product').click(function() {
//     event.preventDefault();
//     // $('.read_more').slideToggle();
//     $('.main-collection-description').toggleClass('active');
//     if ($('.moreless-button_product').text() == "Read more") {
//       $(this).text("<i class="at at-angle-down-l"></i> Read less");
//     } else {
//       $(this).text("<i class="at at-angle-down-l"></i> Read more");
//     }
//   });
// });

$(document).ready(function(){
  $('.moreless-button_product').click(function(event) {
    event.preventDefault();
    $('.main-collection-description').toggleClass('active');
    var $this = $(this);
    
    if ($this.text().trim() == "Read more") {
      $this.contents().filter(function() {
        return this.nodeType === 3; // Only target text nodes
      })[0].nodeValue = " Read less";
    } else {
      $this.contents().filter(function() {
        return this.nodeType === 3; // Only target text nodes
      })[0].nodeValue = " Read more";
    }
  });
});

// Jquery for partner section in mobile
$(document).ready(function() {
    if ($(window).width() <= 766) {
        $(window).on('scroll', function() {
            var toslySection = $('tolstoy-stories');
            if (toslySection.length > 0) {
                var toslySectionOffset = toslySection.offset().top;
                var scrollPosition = $(window).scrollTop();
                var windowHeight = $(window).height();
                if (scrollPosition + windowHeight > toslySectionOffset) {
                    $('body').addClass('custom-sticky');
                } else {
                    $('body').removeClass('custom-sticky');
                }
            }
        });
    }
});
$(document).ready(function () {
    const priceSection = $('.custom_payment_icons');
    const swatch2Select = $('.swatch2-select'); 
    function moveblock() {
        const isMobile = $(window).width() <= 766;
        if (isMobile && priceSection.length && swatch2Select.length) {
            priceSection.after(swatch2Select);
        }
    }
    moveblock();
    $(window).resize(function () {
        moveblock();
    });
});

// Jquery for New color label 
// jQuery(document).ready(function ($) {
//     $(".grid__item").each(function () {
//         var productCard = $(this); // Find the related product card
//         var newColourLabels = productCard.find(".lbl_new_colour");

//         // Hide all labels initially
//         newColourLabels.hide();

//         // Find the default variant (first visible swatch)
//         var defaultVariant = productCard.find(".grswatches .swatch").first();
//         if (defaultVariant.length > 0) {
//             var defaultColor = defaultVariant.attr("title").trim(); // Get the first variant's color

//             // Show NEW COLOUR label only if the first variant has the tag
//             newColourLabels.each(function () {
//                 var variantColor = $(this).data("color").trim();
//                 var isNewColour = $(this).data("new-colour");

//                 if (variantColor.toLowerCase() === defaultColor.toLowerCase() && isNewColour) {
//                     $(this).show();
//                     return false; // Stop loop after first match
//                 }
//             });
//         }
//     });

//     $(".grswatches .swatch").on("click", function () {
//         var selectedColor = $(this).attr("title").trim(); // Get selected color
//         var productCard = $(this).closest(".grid__item"); // Find related product card
//         var newColourLabels = productCard.find(".lbl_new_colour");

//         // Hide all NEW COLOUR labels initially
//         newColourLabels.hide();

//         // Find the matching variant with NEW COLOUR tag
//         newColourLabels.each(function () {
//             var variantColor = $(this).data("color").trim();
//             var isNewColour = $(this).data("new-colour");

//             if (variantColor.toLowerCase() === selectedColor.toLowerCase() && isNewColour) {
//                 $(this).show(); // Show the correct NEW COLOUR label
//             }
//         });
//     });
// });

// Window resize video JS


//   function handleVideoResize() {
//   const video = document.querySelector('.slide-video');
//   if (!video) return;

//   const mobileSrc = video.dataset.mobile;
//   const desktopSrc = video.dataset.desktop;

//   if (window.innerWidth <= 767 && video.currentSrc !== mobileSrc) {
//     video.src = mobileSrc;
//     video.load();
//     video.play();
//   } else if (window.innerWidth >= 768 && video.currentSrc !== desktopSrc) {
//     video.src = desktopSrc;
//     video.load();
//     video.play();
//   }
// }

// window.addEventListener('resize', handleVideoResize);
// window.addEventListener('load', handleVideoResize);

function updateResponsiveVideo(video) {
  const mobileSrc = video.dataset.mobile;
  const desktopSrc = video.dataset.desktop;

  if (window.innerWidth <= 767 && mobileSrc) {
    if (video.src !== mobileSrc) {
      video.src = mobileSrc;
      video.load();
      video.play().catch(()=>{});
    }
  } else if (window.innerWidth >= 768 && desktopSrc) {
    if (video.src !== desktopSrc) {
      video.src = desktopSrc;
      video.load();
      video.play().catch(()=>{});
    }
  }
}

function initResponsiveVideos() {
  const videos = document.querySelectorAll('.slide-video');
  if (!videos.length) return;

  // Initial load
  videos.forEach(updateResponsiveVideo);

  // Handle resize
  window.addEventListener('resize', () => {
    videos.forEach(updateResponsiveVideo);
  });
}

document.addEventListener('DOMContentLoaded', initResponsiveVideos);

// Window resize video JS

// Mobile Submenu Toggle Script Start
document.addEventListener("DOMContentLoaded", function () {
  const mobNavWr = document.querySelector(".mob_nav_wr");
  const mobNav = document.getElementById("mob_nav");
  if (!mobNav) return;

  const norm = (p) => (p || "/").replace(/\/$/, "") || "/";

  function expandActivePathOnMenuOpen() {
    const currentPath = norm(window.location.pathname);
    let activeLink = null;
    for (const link of mobNav.querySelectorAll("a[href]")) {
      const href = link.getAttribute("href");
      if (!href || href === "#") continue;
      if (norm(href.split("?")[0]) === currentPath) {
        activeLink = link;
        break;
      }
    }
    if (!activeLink) return;

    let sub = activeLink.closest(".subLinks") ?? activeLink.closest("li")?.querySelector(":scope > .subLinks");
    while (sub) {
      sub.classList.add("active");
      let el = sub.parentElement;
      sub = null;
      while (el) {
        if (el.classList?.contains("subLinks")) {
          sub = el;
          break;
        }
        el = el.parentElement;
      }
    }
  }

  if (mobNavWr) {
    let hasExpandedOnce = false;
    const observer = new MutationObserver(() => {
      if (!mobNavWr.classList.contains("active")) return;
      if (!hasExpandedOnce) {
        hasExpandedOnce = true;
        expandActivePathOnMenuOpen();
      }
    });
    observer.observe(mobNavWr, { attributes: true, attributeFilter: ["class"] });

    mobNavWr.addEventListener("click", (e) => {
      const icon = e.target.closest("#mob_nav .at:not(.at-arw-left)");
      if (icon) {
        e.preventDefault();
        e.stopPropagation();
        const subLinks = icon.closest("li")?.querySelector(".subLinks");
        if (subLinks) subLinks.classList.toggle("active");
        return;
      }
      const backHeader = e.target.closest("#mob_nav .subLinks .subLinks_menu-nav-header");
      if (backHeader) {
        e.preventDefault();
        e.stopPropagation();
        backHeader.closest(".subLinks")?.classList.remove("active");
      }
    });
  }
});
// Mobile Submenu Toggle Script End